"use strict";
(globalThis["webpackChunktvg_shopify_theme"] = globalThis["webpackChunktvg_shopify_theme"] || []).push([[7729],{

/***/ 7699:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);
/* harmony import */ var _customer_value_from_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(153);



class GlobalBannerController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static targets = ['container', 'image', 'text']
  static COOKIE_NAME = 'banner_settings'
  static COOKIE_EXPIRY_DAYS = 1
  static DEFAULT_THEME = 'light'

  connect() {
    this.initializeBanner()
  }

  initializeBanner() {
    const urlParams = new URLSearchParams(window.location.search)
    const theme = urlParams.get('banner_theme')
    const text = urlParams.get('banner_text')
    const image = urlParams.get('banner_image_url')
    const url = urlParams.get('banner_url')
    const enabled = urlParams.get('show_banner')
    const persistBanner = urlParams.get('persist_banner') === 'true'

    if (enabled) {
      // Banner exists in URL params
      this.render(enabled, theme, text, image, url)

      if (persistBanner) {
        // Banner is persistent, store in cookie
        this.storeInCookie(enabled, theme, text, image, url)
      } else {
        // Banner is not persistent, clear cookie (in case it was set from a previous banner)
        this.clearCookie()
      }
    } else {
      // Banner does not exist in URL params, render from cookie as a fallback
      this.renderFromCookie()
    }
  }

  renderFromCookie() {
    const cookie = (0,_customer_value_from_cookie__WEBPACK_IMPORTED_MODULE_1__.valueFromCookie)(GlobalBannerController.COOKIE_NAME)[0]

    if (cookie) {
      try {
        const { enabled, theme, text, image, url } = JSON.parse(decodeURIComponent(cookie))
        this.render(enabled, theme, text, image, url)
      } catch (e) {
        console.error('Failed to parse banner settings from cookie:', e)
        this.clearCookie() // Clear invalid cookie
      }
    }
  }

  storeInCookie(enabled, theme, text, image, url) {
    const date = new Date()
    date.setTime(date.getTime() + (GlobalBannerController.COOKIE_EXPIRY_DAYS * 24 * 60 * 60 * 1000))
    const cookieValue = JSON.stringify({ enabled, theme, text, image, url })
    document.cookie = `${GlobalBannerController.COOKIE_NAME}=${encodeURIComponent(cookieValue)};expires=${date.toUTCString()};path=/`
  }

  clearCookie() {
    document.cookie = `${GlobalBannerController.COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
  }

  render(enabled = 'false', theme = GlobalBannerController.DEFAULT_THEME, text = null, image = null, url = null) {
    if (enabled === 'false') {
      this.containerTarget.classList.add('hidden')
      return
    }

    this.containerTarget.classList.remove('hidden')
    this.textTarget.textContent = text
    this.containerTarget.dataset.theme = theme

    if (image) {
      this.imageTarget.src = image
      this.imageTarget.classList.remove('hidden')
    }

    if (url) {
      this.containerTarget.onclick = () => {
        window.location.href = url
      }
      this.containerTarget.classList.add('cursor-pointer')
    }
  }

  disconnect() {
    if (this.hasContainerTarget && this.containerTarget.onclick) {
      this.containerTarget.onclick = null
    }
  }
}

Stimulus.register("global-banner", GlobalBannerController)


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(7699)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);